import {
    afterNextRender,
    ChangeDetectionStrategy,
    Component,
    DestroyRef,
    ElementRef,
    inject,
    input,
    viewChild,
} from '@angular/core';

@Component({
    selector: 'qpx-preview-toolbar',
    templateUrl: './preview-toolbar.html',
    styleUrl: './preview-toolbar.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        role: 'toolbar',
        '[attr.aria-label]': 'ariaLabel()',
    },
})
export class PreviewToolbar {
    private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);
    private readonly destroyRef = inject(DestroyRef);
    private readonly center =
        viewChild.required<ElementRef<HTMLElement>>('center');

    //#region Inputs
    public readonly ariaLabel = input.required<string>();
    //#endregion

    constructor() {
        afterNextRender(() => {
            const toolbar = this.host.nativeElement;
            const center = this.center().nativeElement;
            const preview =
                toolbar.closest<HTMLElement>('qpx-file-preview') ??
                toolbar.offsetParent;
            if (!(preview instanceof HTMLElement)) return;
            const updateClearance = () => {
                const bottom = preview.getBoundingClientRect().bottom;
                const controls = center.getBoundingClientRect();
                const clearance =
                    controls.height > 0 ? bottom - controls.top + 8 : 16;
                preview.style.setProperty(
                    '--preview-controls-bottom-space',
                    `${clearance}px`
                );
            };
            const observer = new ResizeObserver(updateClearance);
            observer.observe(center);
            observer.observe(preview);
            updateClearance();
            this.destroyRef.onDestroy(() => {
                observer.disconnect();
                preview.style.removeProperty('--preview-controls-bottom-space');
            });
        });
    }
}
